import { SVGProps, SVGAttributes } from 'react';

const SafetyReportsIcon = (props: SVGProps<SVGAttributes<SVGSVGElement>>) => {
    const { stroke } = props;

    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_5_128" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="49">
                <rect y="0.5" width="48" height="48" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_5_128)">
                <path d="M21 31.5H27V26.5H32V20.5H27V15.5H21V20.5H16V26.5H21V31.5ZM24 44.5C19.3667 43.3333 15.5417 40.675 12.525 36.525C9.50833 32.375 8 27.7667 8 22.7V10.5L24 4.5L40 10.5V22.7C40 27.7667 38.4917 32.375 35.475 36.525C32.4583 40.675 28.6333 43.3333 24 44.5Z"
                      fill={stroke || "#206FA5"}
                />
            </g>
        </svg>

    );
};

export default SafetyReportsIcon;
